module.exports = __webpack_public_path__ + "static/media/temp-program-1-opacity.094cf214.png";